<template>
  <div class="navigation">
    <ul v-for="(categories, groupItemIndex) in navigationItems" :key="groupItemIndex" class="navigation__group-item">
      <li v-for="(category, index) in categories" :key="index" class="navigation__item">
        <restaurant-navigation-category-item v-if="hasChild(category)" v-bind="category" @click="onClick" />
        <restaurant-navigation-category-link-item v-else v-bind="category" />
      </li>
    </ul>
    <restaurant-navigation-resraku-dialog :edit-href="editHref" :is-show="isShowResrakuAlert" @close="onClose" />
  </div>
</template>

<script>
import VueTypes from 'vue-types';
import { VTCategories } from '@/mikan/_shared/types/vueTypes/restaurantNavigation';
import RestaurantNavigationCategoryItem from '@/mikan/_shared/components/molecules/RestaurantNavigationCategoryItem.vue';
import RestaurantNavigationCategoryLinkItem from '@/mikan/_shared/components/molecules/RestaurantNavigationCategoryLinkItem.vue';
import RestaurantNavigationResrakuDialog from '@/mikan/_shared/components/molecules/RestaurantNavigationResrakuDialog.vue';

export default {
  components: {
    RestaurantNavigationCategoryItem,
    RestaurantNavigationCategoryLinkItem,
    RestaurantNavigationResrakuDialog,
  },
  props: {
    navigationItems: VueTypes.arrayOf(VTCategories),
  },
  data() {
    return {
      isShowResrakuAlert: false,
      editHref: '',
    };
  },
  methods: {
    hasChild(item) {
      return item.children && item.children.length > 0;
    },
    onClick(category) {
      if (category.isResrakuAvailable) {
        event.preventDefault();
        this.editHref = category.path;
        this.isShowResrakuAlert = true;
      }
    },
    onClose() {
      this.isShowResrakuAlert = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/mikan/pc/base/constants';

.navigation {
  font-size: $size-s;

  &__group-item:not(:first-child) {
    margin-top: 21px;
  }

  &__item {
    border: 1px solid $color-navy-20;
    border-bottom: 0;

    &:first-child {
      border-top-left-radius: 4px;
      border-top-right-radius: 4px;
    }

    &:last-child {
      border-bottom: 1px solid $color-navy-20;
      border-bottom-left-radius: 4px;
      border-bottom-right-radius: 4px;
    }
  }
}
</style>
